import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  // areaId: Yup.string().required('Area is required'),
  name: Yup.string()
    .required('Group name is required')
    .max(50, 'Maximum length is 50 characters'),
  shortName: Yup.string()
    .required('Group short name is required')
    .max(16, 'Maximum length is 16 characters'),
  resendTimeoutMin: Yup.number()
    .required('Resend Timeout (Min.) is required')
    .typeError('Resend Timeout (Min.) must be a integer')
    .integer('Resend Timeout (Min.) must be a integer'),
  escalationTimeoutMin: Yup.number()
    .required('Escalation Timeout (Min.) is required')
    .typeError('Escalation Timeout (Min.) must be a integer')
    .integer('Escalation Timeout (Min.) must be a integer'),
  departmentId: Yup.string().required('Department is required'),
  uncorrectedMessageTemplate: Yup.string().required(
    'Uncorrected Message Template is required',
  ),
  normalMessageTemplate: Yup.string().required(
    'Normal Message Template is required',
  ),
});
